export default __webpack_public_path__ + "static/anuMehta4-15494033dc91748d2d0a87ab6cee0dcd.jpg";